const PLACES: { [key: string]: string } = {
    CHICAGO: '85940195',
    LONDON: '101750367',
    LOS_ANGELES: '85923517',
    NEW_YORK: '85977539',
    SAN_FRANCISCO: '85922583',
    WASHINGTON_DC: '85931779',
};

// production event IDs mapping
export const FEATURE_EVENTS_MAPPING: { [key: string]: any } = {
    [PLACES.CHICAGO]: [
        '518026931497',
        '597201685317',
        '601459249807',
        '624507918997',
        '638890236897',
    ],
    [PLACES.LONDON]: [
        '503564834977',
        '503575145817',
        '621682738807',
        '634792099257',
        '649704442477',
        '548049810737',
    ],
    [PLACES.LOS_ANGELES]: [
        '511115890387',
        '528825560487',
        '536228843907',
        '598072429737',
    ],
    [PLACES.NEW_YORK]: [
        '609910668227',
        '615860193417',
        '638259710977',
        '560717098937',
        '682715940757',
        '685063522437',
        '661795848197',
    ],

    [PLACES.SAN_FRANCISCO]: [
        '628830407677',
        '624886290717',
        '579791952337',
        '426902024447',
        '632717754837',
    ],
    [PLACES.WASHINGTON_DC]: [
        '274029448457',
        '672533344337',
        '657132830987',
        '579030875937',
        '664742010247',
        '681707123357',
    ],
};
